import React from "react";
import "../../style/customslider.css";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";

function Upcoming() {
  const navigate = useNavigate();

  var settings = {
    // dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          centerMode: true,
          centerPadding: "18px",
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 820,
        settings: {
          centerMode: false,
          slidesToShow: 2.8,
        },
      },
      {
        breakpoint: 700,
        settings: {
          centerMode: false,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 550,
        settings: {
          centerMode: false,
          slidesToShow: 1.5,
        },
      },
      {
        breakpoint: 400,
        settings: {
          centerMode: false,
          slidesToShow: 1.08,
        },
      },
    ],
  };

  const CollectionNavigator = () => {
    navigate("/upcoming-collection");
  };

  return (
    <div className="pt120 pb-3">
      <div className="d-flex justify-content-between align-items-center pb-4">
        <h3>upcoming Collection drops</h3>
        <div>
          <button className="allbutton" onClick={() => CollectionNavigator()}>
            See all
          </button>
        </div>
      </div>

      <Slider {...settings}>
        <div className="cardBox">
          <div className="cardImg">
            <div className="imageDiv">
              <img src="u1.png" alt="card" />
            </div>
            <div className="profileImage">
              <img src="Screen Shot 2021-12-21 at 12.37 9.png" alt="profile" />
            </div>
            <div className="timeCard">02h 48m 55s</div>
          </div>
          <div className="cardName">
            Bubblegoose
            <img src="signed 1.png" alt="tick" className="tick ms-2" />
          </div>
        </div>
        <div className="cardBox">
          <div className="cardImg">
            <div className="imageDiv">
              <img src="u2.png" alt="card" />
            </div>
            <div className="profileImage">
              <img src="Screen Shot 2021-12-21 at 12.37 8.png" alt="profile" />
            </div>
            <div className="timeCard">02h 48m 55s</div>
          </div>
          <div className="cardName">
            DeGods
            <img src="signed 1.png" alt="tick" className="tick ms-2" />
          </div>
        </div>
        <div className="cardBox">
          <div className="cardImg">
            <div className="imageDiv">
              <img src="u3.png" alt="card" />
            </div>
            <div className="profileImage">
              <img src="Screen Shot 2021-12-21 at 12.38 8.png" alt="profile" />
            </div>
            <div className="timeCard">02h 48m 55s</div>
          </div>
          <div className="cardName">
            ApeYachtClub
            <img src="signed 1.png" alt="tick" className="tick ms-2" />
          </div>
        </div>
        <div className="cardBox">
          <div className="cardImg">
            <div className="imageDiv">
              <img src="u5.png" alt="card" />
            </div>
            <div className="profileImage">
              <img src="Screen Shot 2021-12-21 at 12.38 9.png" alt="profile" />
            </div>
            <div className="timeCard">02h 48m 55s</div>
          </div>
          <div className="cardName">
            Midnight Panthers
            <img src="signed 1.png" alt="tick" className="tick ms-2" />
          </div>
        </div>
        <div className="cardBox">
          <div className="cardImg">
            <div className="imageDiv">
              <img src="u4.png" alt="card" />
            </div>
            <div className="profileImage">
              <img src="Screen Shot 2021-12-21 at 12.37 9.png" alt="profile" />
            </div>
            <div className="timeCard">02h 48m 55s</div>
          </div>
          <div className="cardName">
            Bubblegoose
            <img src="signed 1.png" alt="tick" className="tick ms-2" />
          </div>
        </div>
        <div className="cardBox">
          <div className="cardImg">
            <div className="imageDiv">
              <img src="u1.png" alt="card" />
            </div>
            <div className="profileImage">
              <img src="Screen Shot 2021-12-21 at 12.37 8.png" alt="profile" />
            </div>
            <div className="timeCard">02h 48m 55s</div>
          </div>
          <div className="cardName">
            DeGods
            <img src="signed 1.png" alt="tick" className="tick ms-2" />
          </div>
        </div>
        <div className="cardBox">
          <div className="cardImg">
            <div className="imageDiv">
              <img src="u2.png" alt="card" />
            </div>
            <div className="profileImage">
              <img src="Screen Shot 2021-12-21 at 12.38 8.png" alt="profile" />
            </div>
            <div className="timeCard">02h 48m 55s</div>
          </div>
          <div className="cardName">
            ApeYachtClub
            <img src="signed 1.png" alt="tick" className="tick ms-2" />
          </div>
        </div>
        <div className="cardBox">
          <div className="cardImg">
            <div className="imageDiv">
              <img src="u3.png" alt="card" />
            </div>
            <div className="profileImage">
              <img src="Screen Shot 2021-12-21 at 12.38 9.png" alt="profile" />
            </div>
            <div className="timeCard">02h 48m 55s</div>
          </div>
          <div className="cardName">
            Midnight Panthers
            <img src="signed 1.png" alt="tick" className="tick ms-2" />
          </div>
        </div>
      </Slider>

      {/* <div>
        <div className="d-flex gap-3 ">
          <div className="cardBox">
            <div className="cardImg">
              <div className="imageDiv">
                <img src="image 32.png" alt="card" />
              </div>
              <div className="profileImage">
                <img
                  src="Screen Shot 2021-12-21 at 12.37 9.png"
                  alt="profile"
                />
              </div>
              <div className="timeCard">02h 48m 55s</div>
            </div>
            <div className="cardName">
              Bubblegoose
              <img src="signed 1.png" alt="tick" className="tick ms-2" />
            </div>
          </div>
          <div className="cardBox">
            <div className="cardImg">
              <div className="imageDiv">
                <img src="image 32 (1).png" alt="card" />
              </div>
              <div className="profileImage">
                <img
                  src="Screen Shot 2021-12-21 at 12.37 8.png"
                  alt="profile"
                />
              </div>
              <div className="timeCard">02h 48m 55s</div>
            </div>
            <div className="cardName">
              DeGods
              <img src="signed 1.png" alt="tick" className="tick ms-2" />
            </div>
          </div>
          <div className="cardBox">
            <div className="cardImg">
              <div className="imageDiv">
                <img src="image 32 (2).png" alt="card" />
              </div>
              <div className="profileImage">
                <img
                  src="Screen Shot 2021-12-21 at 12.38 8.png"
                  alt="profile"
                />
              </div>
              <div className="timeCard">02h 48m 55s</div>
            </div>
            <div className="cardName">
              ApeYachtClub
              <img src="signed 1.png" alt="tick" className="tick ms-2" />
            </div>
          </div>
          <div className="cardBox">
            <div className="cardImg">
              <div className="imageDiv">
                <img src="image 32 (3).png" alt="card" />
              </div>
              <div className="profileImage">
                <img
                  src="Screen Shot 2021-12-21 at 12.38 9.png"
                  alt="profile"
                />
              </div>
              <div className="timeCard">02h 48m 55s</div>
            </div>
            <div className="cardName">
              Midnight Panthers
              <img src="signed 1.png" alt="tick" className="tick ms-2" />
            </div>
          </div>
        </div>
        <div></div>
      </div> */}
    </div>
  );
}

export default Upcoming;
